module.exports = __webpack_public_path__ + "static/media/wallet_inActive.9dd7224f.png";